import React from 'react';
import PropTypes from 'prop-types';
import {
  BY_SEARCH,
  BY_VENUE_CODE,
  BY_MANUAL_ADDRESS,
} from '../../Constants/venueSearchTypes';

const View = ({
  show,
  venue,
  address,
  venueCode,
  venueName,
  manualAddress,
  venueSearchTypeRadio,
}) =>
  show && (
    <>
      {venueSearchTypeRadio === BY_SEARCH && (
        <>
          <p>{venue}</p>
          <p>{address}</p>
        </>
      )}
      {venueSearchTypeRadio === BY_VENUE_CODE && (
        <>
          <p className="venueCode">{venueCode}</p>
          <p>{venue}</p>
          <p>{address}</p>
        </>
      )}
      {venueSearchTypeRadio === BY_MANUAL_ADDRESS && (
        <>
          <p>{venueName}</p>
          <p>{manualAddress}</p>
        </>
      )}
    </>
  );
View.propTypes = {
  show: PropTypes.bool.isRequired,
  venue: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  venueCode: PropTypes.string.isRequired,
  venueName: PropTypes.string.isRequired,
  manualAddress: PropTypes.string.isRequired,
  venueSearchTypeRadio: PropTypes.string.isRequired,
};

export default View;
